import { render, staticRenderFns } from "./PaperCreateSucceed.vue?vue&type=template&id=c994172c&scoped=true"
import script from "./PaperCreateSucceed.vue?vue&type=script&lang=js"
export * from "./PaperCreateSucceed.vue?vue&type=script&lang=js"
import style0 from "./PaperCreateSucceed.vue?vue&type=style&index=0&id=c994172c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c994172c",
  null
  
)

export default component.exports